/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
/* tslint:disable:max-line-length max-file-line-count*/ // API const file
// The solution discussed in the call of using `` is not working on breaking api endpoints to different line

/**
 * API Map for resolving API endpoints
 * @access public - global
 */

/*****************************************************************
 * TAG MIGRATION FILE
 * 
 * This file manages the APIGEE endpoints that are being retired by the end of 2024
 * 
 * TODO: Remove this file once the migration is complete
 *****************************************************************/
export const API_MAP = {
  API_107_postLinkSIMToAccount: {
    domain: 'esGatewayEndpoint',
    name: 'API_107_postLinkSIMToAccount',
    proxyName: 'customerSupport',
    url: 'account'
  },
  API_108_getValidateSIM: {
    domain: 'esGatewayEndpoint',
    name: 'API_108_getValidateSIM',
    proxyName: 'utility',
    url: 'devices/validate-SIM'
  },
  API_144_getPaymentMethods: {
    domain: 'esGatewayEndpoint',
    name: 'API_144_getPaymentMethods',
    proxyName: 'payment',
    url: 'payment-methods'
  },
  API_144_getSpecificPaymentMethods: {
    domain: 'esGatewayEndpoint',
    name: 'API_144_getSpecificPaymentMethods',
    proxyName: 'payment',
    url: 'customers/payment-methods'
  },
  API_2054_getSecurityQuestions: {
    domain: 'esGatewayEndpoint',
    name: 'API_2054_getSecurityQuestions',
    proxyName: 'customerManageProfile',
    url: 'security-questions'
  },
  API_193_getAvailableMSISDN: {
    domain: 'esGatewayEndpoint',
    name: 'API_193_getAvailableMSISDN',
    proxyName: 'cart',
    url: 'available-msisdn'
  },
  API_202_postPaymentMethods: {
    domain: 'esGatewayEndpoint',
    name: 'API_202_postPaymentMethods',
    proxyName: 'payment',
    url: 'payment-methods'
  },
  API_2055_securityQuestionsAndLinkNumbers: {
    domain: 'esGatewayEndpoint',
    name: 'API_2055_securityQuestionsAndLinkNumbers',
    proxyName: 'customerManageProfile',
    url: 'questions'
  },
  API_2053_postUpdateGeneralProfile: {
    domain: 'esGatewayEndpoint',
    name: 'API_2053_postUpdateGeneralProfile',
    proxyName: 'customerManageProfile',
    url: 'customer/general-profile',
    clearCache: true
  },
  API_216_getAutopay: {
    domain: 'esGatewayEndpoint',
    name: 'API_216_getAutopay',
    proxyName: 'payment',
    url: 'auto-pay'
  },
  API_219_postCreateAutopay: {
    domain: 'esGatewayEndpoint',
    name: 'API_219_postCreateAutopay',
    proxyName: 'payment',
    url: 'auto-pay'
  },
  API_229_getOdaLoginInfo: {
    domain: 'esGatewayEndpoint',
    name: 'API_229_getOdaLoginInfo',
    proxyName: 'auth',
    url: 'customers/{customerId}/lines/{lineId}/oda-login-info?billingType={billingType}'
  },
  API_231_getCustomerAccountLines: {
    domain: 'esGatewayEndpoint',
    name: 'API_231_getCustomerAccountLines',
    proxyName: 'customer',
    url: 'customers/{customerId}/accounts/{accountId}/lines/[lineId]'
  },
  API_237_postValidatePrepaidRefillCard: {
    domain: 'esGatewayEndpoint',
    name: 'API_237_postValidatePrepaidRefillCard',
    proxyName: 'utility',
    url: 'prepaid-topup/validateRefillCard'
  },
  API_238_postPrepaidRefillCardTopup: {
    domain: 'esGatewayEndpoint',
    name: 'API_238_postPrepaidRefillCardTopup',
    proxyName: 'payment',
    url: 'prepaid-topup'
  },
  API_240_getDeviceAssessmentQuestions: {
    domain: 'esGatewayEndpoint',
    name: 'API_240_getDeviceAssessmentQuestions',
    proxyName: 'assistedPurchasePathReturn',
    url: 'device-assessment-questions'
  },
  API_266_postInputValidator: {
    domain: 'esGatewayEndpoint',
    name: 'API_266_postInputValidator',
    proxyName: 'utility',
    url: 'general-info/input-validator'
  },
  API_267_cancelAutoPay: {
    domain: 'esGatewayEndpoint',
    name: 'API_267_cancelAutoPay',
    proxyName: 'payment',
    url: 'prepaid-topup/cancel'
  },
  API_300_getdataStashDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_300_getdataStashDetails',
    proxyName: '',
    url: 'customer/v1/customers/{customerId}/accounts/{accountId}/line-usage'
  },
  API_301_getAccountActivitySummary: {
    domain: 'esGatewayEndpoint',
    name: 'API_301_getAccountActivitySummary',
    proxyName: 'customer',
    url: 'customers/{customerId}/accounts/{accountId}/activity-summary'
  },

  API_2041_getAccountActivitySummary: {
    domain: 'esGatewayEndpoint',
    name: 'API_2041_getAccountActivitySummary',
    proxyName: 'customer',
    url: 'activity-summary'
  },
  API_308_retrievePukData: {
    domain: 'esGatewayEndpoint',
    name: 'API_308_retrievePukData',
    proxyName: 'customerSupport',
    url: 'general-info/sim/{simNumber}'
  },
  API_316_postRemoveSuspension: {
    domain: 'esGatewayEndpoint',
    name: 'API_316_postRemoveSuspension',
    proxyName: 'customerSupport',
    url: 'customers/{customerId}/accounts/{accountId}/remove-suspension'
  },
  API_337_getSpecialInstructions: {
    domain: 'esGatewayEndpoint',
    name: 'API_337_getSpecialInstructions',
    proxyName: 'assistedLookup',
    url: 'customers/{customerId}/accounts/{accountId}/special-instructions'
  },
  API_339_postCallHistory: {
    domain: 'esGatewayEndpoint',
    name: 'API_339_postCallHistory',
    proxyName: 'customer',
    url: 'customers/accounts/call-history'
  },
  API_340_postCreateOrder: {
    domain: 'esGatewayEndpoint',
    name: 'API_340_postCreateOrder',
    proxyName: 'order',
    url: 'orders'
  },
  API_342_getNotifications: {
    domain: 'esGatewayEndpoint',
    name: 'API_342_getNotifications',
    proxyName: 'customer',
    url: 'customers/{customerId}/notifications'
  },
  API_348_getStatesFromType: {
    domain: 'esGatewayEndpoint',
    name: 'API_348_getStatesFromType',
    proxyName: 'referenceList',
    url: 'reference-list/states'
  },
  API_353_getRepDashLookupCriteria: {
    domain: 'esGatewayEndpoint',
    name: 'API_353_getRepDashLookupCriteria',
    proxyName: 'referenceList',
    url: 'reference-list'
  },
  API_2051_getTransactionSummary: {
    domain: 'esGatewayEndpoint',
    name: 'API_2051_getTransactionSummary',
    proxyName: 'customer',
    url: 'account/transaction-summary'
  },
  API_2052_getTransactionDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2052_getTransactionDetails',
    proxyName: 'customer',
    url: 'account/transaction-detail'
  },
  API_369_postFamilyControls: {
    domain: 'esGatewayEndpoint',
    name: 'API_369_postFamilyControls',
    proxyName: 'customerManageProfile',
    url: 'customers/{customerId}/accounts/{accountId}/save-settings'
  },
  API_370_postBlockingControls: {
    domain: 'esGatewayEndpoint',
    name: 'API_370_postBlockingControls',
    proxyName: 'customerManageProfile',
    url: 'customers/{customerId}/accounts/{accountId}/save-blocking-controls'
  },
  API_373_postAccountSettings: {
    domain: 'esGatewayEndpoint',
    name: 'API_373_postAccountSettings',
    proxyName: 'customerManageProfile',
    url: 'customers/{customerId}/accounts/{accountId}/settings'
  },
  API_399_postDataStashOverride: {
    domain: 'esGatewayEndpoint',
    name: 'API_399_postDataStashOverride',
    proxyName: '',
    url: 'assisted-customer-manage-profile/v1/lineofservice/{lineOfServiceId}/databuckets'
  },
  API_400_postReleaseMSISDN: {
    domain: 'esGatewayEndpoint',
    name: 'API_400_postReleaseMSISDN',
    proxyName: 'customerSupport',
    url: 'release-msisdn'
  },
  API_406_getAreaExchangeCode: {
    domain: 'esGatewayEndpoint',
    name: 'API_406_getAreaExchangeCode',
    proxyName: 'utility',
    url: 'utility/area-exchange-code'
  },
  API_415_postValidateBarCode: {
    domain: 'esGatewayEndpoint',
    name: 'API_415_postValidateBarCode',
    proxyName: 'utility',
    url: 'utility/store-barcode'
  },
  API_416_lockOrder: {
    domain: 'esGatewayEndpoint',
    name: 'API_416_lockOrder',
    proxyName: 'order',
    url: 'orders/{orderId}/lock-unlock'
  },
  API_2048_manageSpecialInstruction : {
    domain: 'esGatewayEndpoint',
    name: 'API_2048_manageSpecialInstruction ',
    proxyName: 'assistedCustomerManageProfile',
    url: 'special-instructions',
    clearCache: true
  },
  API_419_getEligiblePaymentMethods: {
    domain: 'esGatewayEndpoint',
    name: 'API_419_getEligiblePaymentMethods',
    proxyName: 'payment',
    url: 'utility/eligible-payment-methods'
  },
  API_448_getCustomerInfo: {
    domain: 'esGatewayEndpoint',
    name: 'API_448_getCustomerInfo',
    proxyName: 'customer',
    url: 'customers/{customerId}/info'
  },
  API_451_getCustomerAccount: {
    domain: 'esGatewayEndpoint',
    name: 'API_451_getCustomerAccount',
    proxyName: 'customer',
    url: 'customers/{customerId}/accounts/{accountId}/info'
  },
  API_465_getRecentBills: {
    domain: 'esGatewayEndpoint',
    name: 'API_465_getRecentBills',
    proxyName: 'customerBilling',
    url: 'customers/{customerId}/accounts/{accountId}/recentBills'
  },
  API_477_postCart_create: {
    domain: 'esGatewayEndpoint',
    name: 'API_477_postCart_create',
    proxyName: '',
    url: 'purchase-path-cart/v1/cart'
  },
  API_487_postValidatePaymentMethod: {
    domain: 'esGatewayEndpoint',
    name: 'API_487_postValidatePaymentMethod',
    proxyName: 'payment',
    url: 'payments/validate-payment'
  },
  API_493_getSubscriberSegmentation: {
    domain: 'esGatewayEndpoint',
    name: 'API_493_getSubscriberSegmentation',
    proxyName: 'auth',
    url: 'customers/segmentation'
  },
  API_497_retrieveDocuments: {
    domain: 'esGatewayEndpoint',
    name: 'API_497_retrieveDocuments',
    proxyName: 'utility',
    url: 'retrieveDocuments'
  },
  API_505_getLoggingLevel: {
    domain: 'esGatewayEndpoint',
    name: 'API_505_getLoggingLevel',
    proxyName: 'utility',
    url: 'getLoggingLevel'
  },
  API_507_postReserveMSISDN: {
    domain: 'esGatewayEndpoint',
    name: 'API_507_postReserveMSISDN',
    proxyName: '',
    url: 'purchase-path-account/v1/reserve-msisdn'
  },
  API_508_getPaymentDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_508_getPaymentDetails',
    proxyName: 'payment',
    url: 'paymentDetails'
  },
  API_511_postChargeDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_511_postChargeDetails',
    proxyName: 'payment',
    url: 'addCharge'
  },
  API_2056_getEligiblePrimaryMobileNumbers: {
    domain: 'esGatewayEndpoint',
    name: 'API_2056_getEligiblePrimaryMobileNumbers',
    proxyName: 'customerManageProfile',
    url: 'getPrimaryNumber'
  },
  API_531_fetchPhysicalDrawerDetail: {
    domain: 'esGatewayEndpoint',
    name: 'API_531_fetchPhysicalDrawerDetail',
    proxyName: 'utility',
    url: 'fetchDrawerDetails'
  },
  API_532_getListOfRestrictions: {
    domain: 'esGatewayEndpoint',
    name: 'API_532_getListOfRestrictions',
    proxyName: 'product',
    url: 'offering-restrictions'
  },
  API_515_sendEmail: {
    domain: 'esGatewayEndpoint',
    name: 'API_515_sendEmail',
    proxyName: 'utility',
    url: 'sendEmail'
  },
  API_518_Permissions: {
    domain: 'esGatewayEndpoint',
    name: 'API_518_Permissions',
    proxyName: 'auth',
    url: 'permissions'
  },
  API_522_log: {
    domain: 'esGatewayEndpoint',
    name: 'API_522_log',
    proxyName: 'common',
    url: 'las'
  },
  API_528_getCardLogo: {
    domain: 'esGatewayEndpoint',
    name: 'API_528_getCardLogo',
    proxyName: 'payment',
    url: 'card-logo'
  },
  API_2005_termsAndConditionsContent: {
    domain: 'esGatewayEndpoint',
    name: 'API_2005_termsAndConditionsContent',
    proxyName: 'document',
    url: 'documents'
  },
  API_2006_customerAccountBillingSummary: {
    domain: 'esGatewayEndpoint',
    name: 'API_2006_customerAccountBillingSummary',
    proxyName: 'customerBilling',
    url: 'account/billingdetails',
    storeActivityId: true
  },
  API_2007_getCustomerDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2007_getCustomerDetails',
    proxyName: 'customer',
    url: 'customers/customerDetails/search',
    storeActivityId: true
  },
  API_2008_CustomerLineBillingDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2008_CustomerLineBillingDetails',
    proxyName: 'customerBilling',
    url: 'account/line/billingdetails'
  },
  API_2009_customerAccountLineUsageDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2009_customerAccountLineUsageDetails',
    proxyName: 'customerBilling',
    url: 'account/line/usagedetails'
  },
  API_2010_customerAccountLineSessionPassDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2010_customerAccountLineSessionPassDetails',
    proxyName: 'customerBilling',
    url: 'account/line/sessionpass'
  },
  API_2016_postCustomerVerification: {
    domain: 'esGatewayEndpoint',
    name: 'API_2016_postCustomerVerification',
    proxyName: 'utility',
    url: 'verification'
  },
  API_2018_AccountBillSummary: {
    domain: 'esGatewayEndpoint',
    name: 'API_2018_AccountBillSummary',
    proxyName: 'customerBilling',
    url: 'billsummary'
  },
  API_2019_getBillDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2019_accountBillDetails',
    proxyName: 'customerBilling',
    url: 'customers/bill-details'
  },
  API_2021_getRepDashLookupCriteria: {
    domain: 'esGatewayEndpoint',
    name: 'API_2021_getRepDashLookupCriteria',
    proxyName: 'referenceList',
    url: 'reference-list'
  },
  API_2022_CustomerAccountLineDeviceDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2022_CustomerAccountLineDeviceDetails',
    proxyName: 'customer',
    url: 'customer/account/line/devicedetails'
  },
  API_2023_CustomerAccountLineServiceDepositDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2023_CustomerAccountLineServiceDepositDetails',
    proxyName: '',
    url: 'v1/customer-billing/account/line/servicedepositdetails'
  },
  API_2025_CustomerNotifications: {
    domain: 'esGatewayEndpoint',
    name: 'API_2025_CustomerNotifications',
    proxyName: 'customer',
    url: 'customer/account/customernotifications'
  },
  API_2026_AccountLineDeviceEIPDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2026_AccountLineDeviceEIPDetails',
    proxyName: '',
    url: 'v1/customer-billing/account/line/device/eipdetails'
  },
  API_2033_changeLine: {
    domain: 'esGatewayEndpoint',
    name: 'API_2033_changeLine',
    proxyName: 'cart',
    url: 'changeLine',
    clearCache: true
  },
  API_2033_postReferenceDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2033_referenceDetails',
    proxyName: 'riskAssessment',
    url: 'referenceDetails'
  },
  API_2036_postcustomerAccountBillingPreferences: {
    domain: 'esGatewayEndpoint',
    name: 'API_2036_postcustomerAccountBillingPreferences',
    proxyName: 'customerBilling',
    url: 'billingdetails'
  },
  API_2037_updateCustomerAccountBillingPreferences: {
    domain: 'esGatewayEndpoint',
    name: 'API_2037_updateCustomerAccountBillingPreferences',
    proxyName: 'customerBilling',
    url: 'billingdetail'
  },
  API_2038_getExistingLines: {
    domain: 'esGatewayEndpoint',
    name: 'API_2038_getExistingLines',
    proxyName: 'customer',
    url: 'existingLines'
  },
  API_2049_enableDisableLineFeatures: {
    domain: 'esGatewayEndpoint',
    name: 'API_2049_enableDisableLineFeatures',
    proxyName: 'customer',
    url: 'account/line/features',
    clearCache: true
  },
  API_2045_manageBlackList: {
    domain: 'esGatewayEndpoint',
    name: 'API_2045_manageBlackList',
    proxyName: 'customerSupport',
    url: 'manageBlackList',
    clearCache: true
  },
  API_2057_getappInfo: {
    domain: 'esGatewayEndpoint',
    name: 'API_2057_getappInfo',
    proxyName: 'customerManageProfile',
    url: 'CustomerAppInfo'
  },
  API_2058_postAppInfo: {
    domain: 'esGatewayEndpoint',
    name: 'API_2058_postAppInfo',
    proxyName: 'customerManageProfile',
    url: 'postAppInfo',
    clearCache: true
  },
  API_2059_getOffer: {
    domain: 'esGatewayEndpoint',
    name: 'API_2059_getOffer',
    proxyName: 'customerManageProfile',
    url: 'get-offers'
  },
  API_2060_updateOffer: {
    domain: 'esGatewayEndpoint',
    name: 'API_2060_updateOffer',
    proxyName: 'customerManageProfile',
    url: 'updateOffer'
  },
  API_2061_getStates: {
    domain: 'esGatewayEndpoint',
    name: 'API_2061_getStates',
    proxyName: 'referenceList',
    url: 'reference-list/states'
  },
  API_2065_getCustomer: {
    domain: 'esGatewayEndpoint',
    name: 'API_2065_getCustomer',
    proxyName: 'customer',
    url: 'getCustomer'
  },
  API_2101_retrieveProductDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2101_retrieveProductDetails',
    proxyName: 'product',
    url: 'products/{canonicalUrl}?data={isProductAvailable}'
  },
  API_2102_retrieveservices: {
    domain: 'esGatewayEndpoint',
    name: 'API_2102_retrieveservices',
    proxyName: 'product',
    url: 'products/{cartId}/lines/{lineId}/services'
  },
  API_2103_generateToken: {
    domain: 'esGatewayEndpoint',
    name: 'API_2103_generateToken',
    proxyName: '',
    url: 'v2/token',
  },
  API_2104_createLineAndAddDevice: {
    domain: 'esGatewayEndpoint',
    name: 'API_2104_createLineAndAddDevice',
    proxyName: 'cart',
    url: 'carts/{cartId}/lines/devices'
  },
  API_2105_updateAccessory: {
    domain: 'esGatewayEndpoint',
    name: 'API_2105_updateAccessory',
    proxyName: '',
    url: 'v2/carts/{cartId}/accessories/{accessoryId}'
  },
  API_2106_deleteLine: {
    domain: 'esGatewayEndpoint',
    name: 'API_2106_deleteLine',
    proxyName: 'cart',
    url: 'carts/{cartId}/lines/{lineId}'
  },
  API_2107_addingDeviceToNonLineItem: {
    domain: 'esGatewayEndpoint',
    name: 'API_2107_addingDeviceToNonLineItem',
    proxyName: 'cart',
    url: 'carts/{cartId}/devices'
  },
  API_2108_updatePlanConflicts: {
    domain: 'esGatewayEndpoint',
    name: 'API_2108_updatePlanConflicts',
    proxyName: '',
    url: 'v2/{cartId}/plan-configurations/{planConfigId}/plan-options/{planOptionSelectorId}'
  },
  API_2111_addDeviceToLine: {
    domain: 'esGatewayEndpoint',
    name: 'API_2111_addDeviceToLine',
    proxyName: 'cart',
    url: 'carts/{cartId}/lines/{lineId}/device'
  },
  API_2112_serviceBundle: {
    domain: 'esGatewayEndpoint',
    name: 'API_2112_serviceBundle',
    proxyName: 'cart',
    url: 'carts/{cartId}/lines/{lineId}/services/bundle',
    clearCache: true
  },
  API_2113_postServiceSelection: {
    domain: 'esGatewayEndpoint',
    name: 'API_2113_postServiceSelection',
    proxyName: 'product',
    url: 'products/{cartId}/lines/{lineId}/services',
    clearCache: true
  },
  API_2114_applyPromotions: {
    domain: 'esGatewayEndpoint',
    name: 'API_2114_applyPromotions',
    proxyName: 'cart',
    url: 'carts/{cartId}/promotions',
  },
  API_2119_addAccessoriesToCart: {
    domain: 'esGatewayEndpoint',
    name: 'API_2119_addAccessoriesToCart',
    proxyName: '',
    url: 'v2/carts/{cartId}/accessories'
  },
  API_2121_deleteCart: {
    domain: 'esGatewayEndpoint',
    name: 'API_2121_deleteCart',
    proxyName: 'cart',
    url: 'carts/{cartId}',
  },
  API_2174_cancelCheckoutOrder: {
    domain: 'esGatewayEndpoint',
    name: 'API_2174_cancelCheckoutOrder',
    proxyName: 'orders',
    url: 'checkout/{cartId}'
  },
  API_2122_deleteCartLevelDevice: {
    domain: 'esGatewayEndpoint',
    name: 'API_2122_deleteCartLevelDevice',
    proxyName: 'cart',
    url: 'carts/{cartId}/devices/{deviceId}'
  },
  API_2123_postItemValidation: {
    domain: 'esGatewayEndpoint',
    name: 'API_2123_postItemValidation',
    proxyName: 'cart',
    url: '{cartId}/postItemValidation'
  },
  API_2148_retrieveProductPlansPdp: {
    domain: 'esGatewayEndpoint',
    name: 'API_2148_retrieveProductPlansPdp',
    proxyName: 'product',
    url: 'products/plans/{familyId}'
  },
  API_2149_getSerializationInfo: {
    domain: 'esGatewayEndpoint',
    name: 'API_2149_getSerializationInfo',
    proxyName: 'supplychainInventorysale',
    url: 'configurableProperties'
  },
  API_2151_getSalesSNValidation: {
    domain: 'esGatewayEndpoint',
    name: 'API_2151_getSalesSNValidation',
    proxyName: 'supplychainInventorysale',
    url: 'saleItem'
  },
  API_2156_overridePrice: {
    domain: 'esGatewayEndpoint',
    name: 'API_2156_overridePrice',
    proxyName: 'cart',
    url: 'overridePrice'
  },
  API_2126_duplicateLineInCart: {
    domain: 'esGatewayEndpoint',
    name: 'API_2126_duplicateLines',
    proxyName: 'cart',
    url: 'cart/{cartId}/duplicateLines'
  },
  API_2152_getReturnSNValidation: {
    domain: 'esGatewayEndpoint',
    name: 'API_2152_getReturnSNValidation',
    proxyName: 'supplychainInventorysale',
    url: 'returnItem'
  },
  API_2819_postDeviceHistory: {
    domain: 'esGatewayEndpoint',
    name: 'API_2819_postDeviceHistory',
    proxyName: 'customer',
    url: 'deviceHistory'
  },
  API_2128_postWarrantyToCart: {
    domain: 'esGatewayEndpoint',
    name: 'API_2128_postWarrantyToCart',
    proxyName: 'cart',
    url: 'carts/{cartId}/lines/{lineId}/warranty'
  },
  API_2129_putWarrantyToCart: {
    domain: 'esGatewayEndpoint',
    name: 'API_2129_putWarrantyToCart',
    proxyName: 'cart',
    url: 'carts/{cartId}/lines/{lineId}/warranty'
  },
  API_2131_retrieveCart: {
    domain: 'esGatewayEndpoint',
    name: 'API_2131_retrieveCart',
    proxyName: 'cart',
    url: 'cart/{cartId}',
  },
  API_2133_postSetEffectiveDate: {
    domain: 'esGatewayEndpoint',
    name: 'API_2133_postSetEffectiveDate',
    proxyName: 'cart',
    url: 'cart/{cartId}/seteffectivedate',
    clearCache: true
  },
  API_2134_postRemorseToCartAsLineItem: {
    domain: 'esGatewayEndpoint',
    name: 'API_2134_postRemorseToCartAsLineItem',
    proxyName: 'cart',
    url: 'carts/{cartId}/lines/{lineId}/remorse'
  },
  API_2135_putRemorseToCartAsLineItem: {
    domain: 'esGatewayEndpoint',
    name: 'API_2135_putRemorseToCartAsLineItem',
    proxyName: 'cart',
    url: 'carts/{cartId}/lines/{lineId}/remorse'
  },
  API_2136_putRemorseToCart: {
    domain: 'esGatewayEndpoint',
    name: 'API_2136_putRemorseToCart',
    proxyName: 'cart',
    url: 'carts/{cartId}/remorse'
  },
  API_2137_postRemorseToCart: {
    domain: 'esGatewayEndpoint',
    name: 'API_2137_postRemorseToCart',
    proxyName: 'cart',
    url: 'carts/{cartId}/remorse'
  },
  API_2138_retrieveSessionPasses: {
    domain: 'esGatewayEndpoint',
    name: 'API_2138_retrieveSessionPasses',
    proxyName: 'product',
    url: 'products/onDemandPass'
  },
  API_2040_lineBillingDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2040_lineBillingDetails',
    proxyName: 'customerBilling',
    url: 'account/line-details',
    storeActivityId: true
  },
  API_2046_changeSIM: {
    domain: 'esGatewayEndpoint',
    name: 'API_2046_changeSIM',
    proxyName: 'customerSupport',
    url: 'lines/addsim',
    clearCache: true
  },
  API_2062_billingAddress: {
    domain: 'esGatewayEndpoint',
    name: 'API_2062_billingAddress',
    proxyName: 'customerBilling',
    url: 'getaddress'
  },
  API_2063_postUpdateAddresses: {
    domain: 'esGatewayEndpoint',
    name: 'API_2063_postUpdateAddresses',
    proxyName: 'customerBilling',
    url: 'updatebillingaddress',
    clearCache: true
  },
  API_2142_convertToLineItem: {
    domain: 'esGatewayEndpoint',
    name: 'API_2142_convertToLineItem',
    proxyName: 'cart',
    url: 'carts/{cartId}/lines/{lineId}/device/{deviceId}/convertToLineItem'
  },
  API_2143_convertToNonLineItem: {
    domain: 'esGatewayEndpoint',
    name: 'API_2143_convertToNonLineItem',
    proxyName: 'cart',
    url: 'carts/{cartId}/lines/{lineId}/device/{deviceId}/convertToNonLineItem'
  },
  API_2501_taxExemption: {
    domain: 'esGatewayEndpoint',
    name: 'API_2501_taxExemption',
    proxyName: 'cart',
    url: '{cartId}/taxExemption'
  },
  API_2147_addSessionPass: {
    domain: 'esGatewayEndpoint',
    name: 'API_2147_addSessionPass',
    proxyName: 'cart',
    url: 'carts/{cartId}/addSessionPass',
    clearCache: true
  },
  API_2208_updateAdjustment: {
    domain: 'esGatewayEndpoint',
    name: 'API_2208_updateAdjustment',
    proxyName: 'assistedRepdash',
    url: 'reps/update-adjustment',
    clearCache: true
  },
  API_2600_postValidatePaymentMethod: {
    domain: 'esGatewayEndpoint',
    name: 'API_2600_postValidatePaymentMethod',
    proxyName: 'payment',
    url: 'payment/validatepaymentmethod'
  },
  API_2603_paymentsDirectToAccount: {
    domain: 'esGatewayEndpoint',
    name: 'API_2603_paymentsDirectToAccount',
    proxyName: 'payment',
    url: 'paymentDirectToAccount'
  },
  API_2604_updatePaymentMethodAddress: {
    domain: 'esGatewayEndpoint',
    name: 'API_2604_updatePaymentMethodAddress',
    proxyName: 'cart',
    url: 'cart/{cartId}/payments/checkoutUpdate'
  },
  API_2606_taxExemption: {
    domain: 'esGatewayEndpoint',
    name: 'API_2606_taxExemption',
    proxyName: 'payment',
    url: 'taxExemption'
  },
  API_2607_updateExistingBalance: {
    domain: 'esGatewayEndpoint',
    name: 'API_2607_updateExistingBalance',
    proxyName: 'cart',
    url: '{cartId}/payments/updateExistingBalance'
  },
  API_2608_updateRefillCard: {
    domain: 'esGatewayEndpoint',
    name: 'API_2608_updateRefillCard',
    proxyName: 'cart',
    url: '{cartId}/payments/updateRefillCard'
  },
  API_2609_updatePayExtraAmount: {
    domain: 'esGatewayEndpoint',
    name: 'API_2609_updatePayExtraAmount',
    proxyName: 'cart',
    url: '{cartId}/payments/updatePayExtraAmount'
  },
  API_2611_cardTypeValidation: {
    domain: 'esGatewayEndpoint',
    name: 'API_2611_cardTypeValidation',
    proxyName: 'payment',
    url: 'cardtypevalidation'
  },
  API_2612_keyManager: {
    domain: 'esGatewayEndpoint',
    name: 'API_2612_keyManager',
    proxyName: 'payment',
    url: 'key-manager'
  },
  API_2613_postNegativeFile: {
    domain: 'esGatewayEndpoint',
    name: 'API_2613_postNegativeFile',
    proxyName: 'payment',
    url: 'negativefile'
  },
  API_2614_postValidation: {
    domain: 'esGatewayEndpoint',
    name: 'API_2614_postValidation',
    proxyName: 'payment',
    url: 'validation'
  },
  API_2615_getAccountFundingOptions: {
    domain: 'esGatewayEndpoint',
    name: 'API_2615_getAccountFundingOptions',
    proxyName: 'cart',
    url: 'accountfunding'
  },
  API_2629_postGetBlockedPayments: {
    domain: 'esGatewayEndpoint',
    name: 'API_2629_postGetBlockedPayments',
    proxyName: 'payment',
    url: 'blockedPayments'
  },
  API_2810_portInEligibility: {
    domain: 'esGatewayEndpoint',
    name: 'API_2810_portInEligibility',
    proxyName: 'numberMgmt',
    url: 'port-in-eligibility'
  },
  API_2812_getNpaByZip: {
    domain: 'esGatewayEndpoint',
    name: 'API_2812_getNpaByZip',
    proxyName: 'numberMgmt',
    url: 'utility/area-exchange-code'
  },
  API_2813_getSearchOrders: {
    domain: 'esGatewayEndpoint',
    name: 'API_2813_getSearchOrders',
    proxyName: 'assistedLookup',
    url: 'orders'
  },
  API_2814_getOrderDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2814_getOrderDetails',
    proxyName: 'order',
    url: 'orders/{orderId}'
  },
  API_2824_retrieveOrderStatus: {
    domain: 'esGatewayEndpoint',
    name: 'API_2824_retrieveOrderStatus',
    proxyName: 'orders',
    url: 'orderStatus'
  },
  API_2815_postCancelOrder: {
    domain: 'esGatewayEndpoint',
    name: 'API_2815_postCancelOrder',
    proxyName: 'order',
    url: 'orders/cancellation/{orderId}',
    clearCache: true
  },
  API_2817_getTotalPending: {
    domain: 'esGatewayEndpoint',
    name: 'API_2817_getTotalPending',
    proxyName: 'customer',
    url: 'orders/pendingOrderCount'
  },
  API_2818_updateMileStone: {
    domain: 'esGatewayEndpoint',
    name: 'API_2818_updateMileStone',
    proxyName: 'order',
    url: 'orders/{orderId}/update-milestone',
    clearCache: true
  },
  API_2900_validateSim: {
    domain: 'esGatewayEndpoint',
    name: 'API_2900_validateSim',
    proxyName: 'numberMgmt',
    url: 'devices/validate-SIM'
  },
  API_2913_getValidateImeiNumber: {
    domain: 'esGatewayEndpoint',
    name: 'API_2913_getValidateImeiNumber',
    proxyName: 'utility',
    url: 'general-info/valid-imei'
  },
  API_366_termsAndConditions: {
    domain: 'esGatewayEndpoint',
    name: 'API_366_termsAndConditions',
    proxyName: 'referenceList',
    url: 'reference-list/terms-conditions'
  },
  API_AutoSuggestion: {
    domain: 'esGatewayEndpoint',
    name: 'API_AutoSuggestion',
    proxyName: 'utility',
    url: 'search/auto-suggest'
  },
  API_SearchResults: {
    domain: 'esGatewayEndpoint',
    name: 'API_SearchResults',
    proxyName: 'utility',
    url: 'global-search/term/{searchTerm}',
  },
  API_2100_retrieveProducts: {
    domain: 'esGatewayEndpoint',
    name: 'API_2100_retrieveProducts',
    proxyName: 'product',
    url: 'products'
  },
  API_2144_compareDevices: {
    domain: 'esGatewayEndpoint',
    name: 'API_2144_compareDevices',
    proxyName: 'product',
    url: 'compareDevices'
  },
  API_2160_searchProducts: {
    domain: 'esGatewayEndpoint',
    name: 'API_2160_searchProducts',
    proxyName: 'product',
    url: 'searchProducts'
  },
  API_2166_retrieveProductCategories: {
    domain: 'esGatewayEndpoint',
    name: 'API_2166_retrieveProductCategories',
    proxyName: 'product',
    url: 'productCategories'
  },
  API_2168_validateImeiAndSim: {
    domain: 'esGatewayEndpoint',
    name: 'API_2168_validateImeiAndSim',
    proxyName: 'product',
    url: 'validateImeiAndSim'
  },
  API_deleteAccessory: {
    domain: 'esGatewayEndpoint',
    name: 'API_deleteAccessory',
    proxyName: '',
    url: 'v2/carts/{cartId}/accessories/{accessoryId}',
  },
  API_108_simValidation: {
    domain: 'esGatewayEndpoint',
    name: 'API_108_simValidation',
    proxyName: 'numberMgmt',
    url: 'devices/validate-SIM'
  },
  API_2001_creditCheck: {
    domain: 'esGatewayEndpoint',
    name: 'API_2001_creditCheck',
    proxyName: 'riskAssessment',
    url: 'creditCustomerDetails'
  },
  API_2002_riskAssessmentIdTypes: {
    domain: 'esGatewayEndpoint',
    name: 'API_2002_riskAssessmentIdTypes',
    proxyName: 'riskAssessment',
    url: 'riskassessmentidtypes'
  },
  API_2003_postEmailValidation: {
    domain: 'esGatewayEndpoint',
    name: 'API_2003_postEmailValidation',
    proxyName: 'riskAssessment',
    url: 'customers/emailVerification'
  },
  API_2004_addressValidation: {
    domain: 'esGatewayEndpoint',
    name: 'API_2004_addressValidation',
    proxyName: 'address',
    url: 'addresses'
  },
  API_2802_updateAddress: {
    domain: 'esGatewayEndpoint',
    name: 'API_2802_updateAddress',
    proxyName: 'cart',
    url: 'profiles/{profileId}/addresses'
  },
  API_2117_retrievePlansForMultiLines: {
    domain: 'esGatewayEndpoint',
    name: 'API_2117_retrievePlansForMultiLines',
    proxyName: 'product',
    url: 'products/plans'
  },
  API_2109_updatePlansToCart: {
    domain: 'esGatewayEndpoint',
    name: 'API_2109_updatePlansToCart',
    proxyName: 'cart',
    url: 'carts/{cartId}/plan-configurations'
  },
  API_2116_postAuditRecords: {
    domain: 'esGatewayEndpoint',
    name: 'API_2116_postAuditRecords',
    proxyName: 'cart',
    url: 'carts/{cartId}/lines/{lineId}/audit-records'
  },
  API_2120_postCheckOutCart: {
    domain: 'esGatewayEndpoint',
    name: 'API_2120_postCheckOutCart',
    proxyName: 'cart',
    url: 'checkout/{cartId}'
  },
  API_2132_globalSearch: {
    domain: 'esGatewayEndpoint',
    name: 'API_2132_globalSearch',
    proxyName: 'utility',
    url: 'global-search/{searchTerm}'
  },
  API_2145_getProductReviews: {
    domain: 'esGatewayEndpoint',
    name  : 'API_2145_getProductReviews',
    proxyName: 'product',
    url  :  'reviews'
  },
  API_2146_postProductReviewFeedback: {
    domain: 'esGatewayEndpoint',
    name  : 'API_2146_postProductReviewFeedback',
    proxyName: 'product',
    url  :  'reviews/products/{productId}/feedback'
  },
  API_2805_orders: {
    domain: 'esGatewayEndpoint',
    name: 'API_2805_orders',
    proxyName: 'order',
    url: 'orders/{cartId}'
  },
  API_2807_getMSISDN: {
    domain: 'esGatewayEndpoint',
    name: 'API_2807_getMSISDN',
    proxyName: 'numberMgmt',
    url: 'available-msisdn'
  },
  API_2809_releaseMSISDN: {
    domain: 'esGatewayEndpoint',
    name: 'API_2809_releaseMSISDN',
    proxyName: 'numberMgmt',
    url: 'release-msisdn'
  },
  API_2808_reserveMSISDN: {
    domain: 'esGatewayEndpoint',
    name: 'API_2808_reserveMSISDN',
    proxyName: 'numberMgmt',
    url: 'reserve-msisdn'
  },
  API_2118_toUpdateLineName: {
    domain: 'esGatewayEndpoint',
    name: 'API_2118_toUpdateLineName',
    proxyName: 'cart',
    url: 'carts/{cartId}/lineSetup'
  },
  API_2150_submitOrder: {
    domain: 'esGatewayEndpoint',
    name: 'API_2150_submitOrder',
    proxyName: 'cart',
    url: 'submit-order/{cartId}',
    clearCache: true
  },
  API_2806_termsAndConditions: {
    domain: 'esGatewayEndpoint',
    name: 'API_2806_termsAndConditions',
    proxyName: 'documentMgmt',
    url: 'retrieve-terms-conditions'
  },
  API_273_getCarrierMakeModels: {
    domain: 'esGatewayEndpoint',
    name: 'API_273_getCarrierMakeModels',
    proxyName: 'referenceList',
    url: 'carriermakemodel'
  },
  API_2127_SimDetails: {
    domain: 'esGatewayEndpoint',
    name: 'API_2127_SimDetails',
    proxyName: 'product',
    url: 'products/items'
  },
  API_372_orders: {
    domain: 'esGatewayEndpoint',
    name: 'API_372_orders',
    proxyName: 'payment',
    url: 'orders/payment-method'
  },
  API_2627_postReverseCreditOrAdjustment: {
    domain: 'esGatewayEndpoint',
    name: 'API_2627_postReverseCreditOrAdjustment',
    proxyName: 'payment',
    url: 'refund'
  },
  API_2628_checkDuplicateFile: {
    domain: 'esGatewayEndpoint',
    name: 'API_2628_checkDuplicateFile',
    proxyName: 'payment',
    url: 'check/duplicate'
  },
  API_2630_getPaymentEligibleCountries: {
    domain: 'esGatewayEndpoint',
    name: 'API_2630_getPaymentEligibleCountries',
    proxyName: 'payment',
    url: 'eligibleCountries'
  },
  API_196_getShippingOptions: {
    domain: 'esGatewayEndpoint',
    name  : 'API_196_getShippingOptions',
    proxyName: 'cart',
    url  :  'shippingoption'
  },
  EPAY_INTEGRATION: {
    domain: 'epayEndpoint',
    name: 'EPAY_INTEGRATION',
    proxyName: '',
    url: 'api/integration/'
  },
  API_3150_submitOrder: {
    domain: 'esGatewayEndpoint',
    name: 'API_3150_submitOrder',
    proxyName: 'cart',
    url: 'submitOrder',
    clearCache: true
  },
  API_2617_getStoredPaymentMethods: {
    domain: 'esGatewayEndpoint',
    name: 'API_2617_getStoredPaymentMethods',
    proxyName: 'payment',
    url: 'customers/payment-methods'
  },
  API_2618_getStoredPaymentMethods: {
    domain: 'esGatewayEndpoint',
    name: 'API_2618_getStoredPaymentMethods',
    proxyName: 'payment',
    url: 'payment-methods'
  },
  API_2619_getStoredPaymentMethods: {
    domain: 'esGatewayEndpoint',
    name: 'API_2619_getStoredPaymentMethods',
    proxyName: 'payment',
    url: 'payment-methods'
  },
  API_2620_getStoredPaymentMethods: {
    domain: 'esGatewayEndpoint',
    name: 'API_2620_getStoredPaymentMethods',
    proxyName: 'payment',
    url: 'payment-methods'
  },
  API_2175_postCartlessCheckout: {
    domain: 'esGatewayEndpoint',
    name: 'API_2175_postCartlessCheckout',
    proxyName: 'payment',
    url: 'cartLessCheckout'
  },
  API_2632_READ_NEGATIVE_FILE: {
    domain: 'esGatewayEndpoint',
    name: 'API_2632_READ_NEGATIVE_FILE',
    proxyName: 'payment',
    url: 'readnegativefile'
  },
  API_2826_postShippingEligiblity: {
    domain: 'esGatewayEndpoint',
    name  : 'API_2826_postShippingEligiblity',
    proxyName: 'order',
    url  :  'return-shipment-eligibility-details'
  },
  API_2827_postchangeMsisdnEligibility: {
    domain: 'esGatewayEndpoint',
    name  : 'API_2827_postchangeMsisdnEligibility',
    proxyName: 'numberMgmt',
    url  :  'changeMsisdnEligibility'
  },
  API_2830_getDocumentsByToken: {
    domain: 'esGatewayEndpoint',
    name  : 'API_2830_getDocumentsByToken',
    proxyName: 'utility',
    url  :  'getDocumentsByToken'
  },
  API_2829_decryptToken: {
    domain: 'esGatewayEndpoint',
    name  : 'API_2829_decryptToken',
    proxyName: 'utility',
    url  :  'decryptToken'
  },
  API_2831_postPauseAndResume: {
    domain: 'esGatewayEndpoint',
    name  : 'API_2831_postPauseAndResume',
    proxyName: 'utility',
    url  :  'call-pause-resume'
  },
  API_2170_getCompatibilityCheck: {
    domain: 'esGatewayEndpoint',
    name: 'API_2170_getCompatibilityCheck',
    proxyName: 'product',
    url: 'devices/compatibility-check'
  },
  API_2832_overrideOTP: {
    domain: 'esGatewayEndpoint',
    name: 'API_2832_overrideOTP',
    proxyName: 'utility',
    url: 'overrideOTP'
  },
  API_2245_coppaPostStoreConsents: {
    domain: 'esGatewayEndpoint',
    name: 'API_2245_coppaPostStoreConsents',
    proxyName: 'customerManageProfile',
    url: 'coppaStoreConsents'
  },
  API_2246_coppaPostConsentsLoad: {
    domain: 'esGatewayEndpoint',
    name: 'API_2246_coppaPostConsentsLoad',
    proxyName: 'customerManageProfile',
    url: 'coppaParentalConsentLoad'
  },
  API_2247_postCoppaRetrieveDocument: {
    domain: 'esGatewayEndpoint',
    name: 'API_2247_postCoppaRetrieveDocument',
    proxyName: 'utility',
    url: 'coppaRetrieveDocuments'
  },
  API_2176_postAutopayIntent: {
    domain: 'esGatewayEndpoint',
    name: 'API_2176_postAutopayIntent',
    proxyName: 'cart',
    url: 'autopayIntent'
  }
};

